<div class="p-dialog-body" [ngClass]="[isFileUploaded ? 'min-h-24' : '']">

    <div class="mb-3">
        <label for="masterPlanId" class="form-label d-block">{{ 'common.fields.common.delimiter' | t }}</label>
        <p-select [options]="delimiters" appendTo="body"
            placeholder="{{ 'common.placeholders.select.select_delimiter' | t }}" [(ngModel)]="defaultDelimiter"
            optionLabel="name" styleClass="w-100 height-px-38" optionValue="value">
            <ng-template let-item pTemplate="item">
                <div title="{{ item.name }}">
                    {{ item.name }}
                </div>
            </ng-template>
        </p-select>
    </div>

    <div>
        <label for="masterPlanId" class="form-label d-block mb-2">{{
            'master_plans.import_jobs.dialog.fields.upload_files' | t }}</label>

        <p-fileUpload name="planZipFile" (onSelect)="onSelect($event)" (mouseenter)="onFileUploadMouseEnter()"
            (mouseleave)="onFileUploadMouseLeave()" (mousemove)="onFileUploadMouseMove()"
            [ngClass]="isFileUploadErr ? 'upload-error':''"
            styleClass="p-progressbar-none drag-area upload-files-outside upload-files-top-170 upload-content-h-160 upload-choose-top-10 file-message-error dropzone-forground"
            [multiple]="false" accept=".txt, .csv, .zip" [auto]="true" [customUpload]="true"
            [maxFileSize]="maxFileSize">
            <!-- <ng-template pTemplate="chooseicon">Browse File</ng-template> -->
            <ng-template #header let-chooseCallback="chooseCallback" class="py-0">
                <div class="z-index-99 d-flex flex-column align-items-center">
                    <h5 class="fs-16 fw-semibold mb-px-2">{{ 'common.upload.general.drag_drop_text' | t }}</h5>
                    <p-button styleClass="fs-15 fileupload-choose" class="my-1" variant="text"
                        (onClick)="chooseFile($event, chooseCallback)"
                        label="{{ 'common.upload.general.browse_file' | t}}">
                    </p-button>
                    <h5 class="fs-13 fw-regular">
                        {{ 'common.upload.general.file_requirements' | t }}
                    </h5>
                    <a (click)="downloadSampleFiles()"
                        class="d-block fs-16 fw-regular mt-4 text-decoration-underline color-gray-900"><i
                            class="z-index-1 fa fa-sign-in fa-rotate-90 fs-22 color-gray-500 me-2"></i>
                        {{ 'master_plans.import_jobs.dialog.upload_area.download_sample' | t }}</a>
                </div>
            </ng-template>

            <ng-template let-file pTemplate="file">
                <!-- Custom UI to display a file -->
                <div class="custom-file-item mb-2">
                    <div class="d-flex">
                        <div class="w-100">
                            <label for="masterPlanId" class="form-label d-block">{{ 'common.fields.common.file' | t
                                }}</label>
                            <div
                                class="border-1 border-style-solid border-gray-300 rounded-px-6 px-11 py-2 d-flex align-items-center justify-content-between height-px-38 gap-2 mb-px-10">
                                <div class="d-flex align-items-center gap-3 flex-1">
                                    <i class="color-gray-500 fa fa-file"></i>
                                    <div class="fs-14 fw-regular line-clamp-1 text-break color-gray-900"
                                        [title]="file.name">
                                        {{ file.name }}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end align-items-center gap-4">
                                    <ng-container *ngIf="isFileUploadStarted">

                                        <div class="d-flex gap-2 w-100 align-items-center">
                                            <p-progressBar [value]="progressBarValue" class="d-block w-100"
                                                styleClass="height-px-6 width-15 position-relative p-progressbar-label-none d-block"></p-progressBar>
                                            <span class="color-gray-500 fs-12">{{ progressBarValue }}%</span>
                                        </div>
                                    </ng-container>
                                    <a href="javascript:void(0)"><i (click)="cancleFile()"
                                            class="color-gray-500 fa fa-times fs-14 hover-color-danger-500"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-fileUpload>
    </div>
</div>

<div class="p-dialog-footer border-top-0">
    <p-button label=" {{ 'common.actions.buttons.cancel' | t }}" variant="text" severity="secondary" (onClick)="dismiss(true)"></p-button>
    <p-button label="{{ 'master_plans.import_jobs.dialog.actions.import' | t }}" [disabled]="!isFileUploaded" (onClick)="onUpload()"></p-button>
</div>